import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ZapOff = createReactComponent("ZapOff", ["svg", defaultAttributes, [["polyline", {
  points: "12.41 6.75 13 2 10.57 4.92",
  key: "11g4b1"
}], ["polyline", {
  points: "18.57 12.91 21 10 15.66 10",
  key: "l0gmze"
}], ["polyline", {
  points: "8 8 3 14 12 14 11 22 16 16",
  key: "1sa4vm"
}], ["line", {
  x1: "1",
  y1: "1",
  x2: "23",
  y2: "23",
  key: "czowfk"
}]]]);
export default ZapOff;